{
  "messages": {
    "rescheduledOnce": "Dijadwalkan ulang sekali",
    "rescheduledTwice": "Dijadwalkan ulang dua kali",
    "rescheduledCountTimes": "Dijadwalkan ulang {count} kali"
  }
}
